import React from 'react';
import JobHeader from '../../../components/header/jobheader/JobHeader';
import '../business/business.css';

const JobLayout = ({ children }) => {
  return (
    <div className="job-page">
      <JobHeader />
      <div className="job-content-container">
        {children}
      </div>
    </div>
  );
};

export default JobLayout; 